import { jwtDecode } from 'jwt-decode';

const REFRESH_TIME_BEFORE_EXPIRATION = 30;

export const calculateTimeUntilRefresh = (accessToken: string): number | undefined => {
  const expiresIn = jwtDecode(accessToken).exp; // expiry date in seconds

  if (!expiresIn) {
    return undefined;
  }

  const currentTime = Math.floor(Date.now() / 1000); // current time in seconds
  return expiresIn - REFRESH_TIME_BEFORE_EXPIRATION - currentTime; // refresh 30 seconds before expiration
};

export const hasExpired = (accessToken: string): boolean => {
  const expiresIn = jwtDecode(accessToken).exp; // expiry date in seconds

  if (!expiresIn) {
    return true;
  }

  const currentTime = Math.floor(Date.now() / 1000); // current time in seconds
  return expiresIn - REFRESH_TIME_BEFORE_EXPIRATION < currentTime; // interceptor should refresh 30 seconds before expiration
};
